import { render, staticRenderFns } from "./message.vue?vue&type=template&id=4a9f5a14&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "message.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/message/message.vue
// module id = 139
// module chunks = 0